import { SiteWiseAuditeeBean } from './site-wise-auditee-bean';
import { AuditorAuditeePermissionDeptWiseBean } from './auditor-auditee-permission-dept-wise-bean';

export class AuditorAuditeePermissionResponseBean {

    roleId: number;
    roleName: string;
    cdAccessType: string;
    isRoleMandatory: string;
    siteWiseAuditeeBeanList: SiteWiseAuditeeBean[];
    permissionRoleNDeptWiseBeanList: AuditorAuditeePermissionDeptWiseBean[];
}
